/**
 * google测试环境无法使用
 * @author 
 */
import events from '../../../base/events';
import { cbHost, upInfoInSNS } from '../config';
import Cache from 'c-cache';
import notification from 'c-notification';
import CheckRegister from '../thirdparty/check';
import Register from '../thirdparty/register';
import UserLogin from '../../profile/login';
import loading from 'c-up-loading';
import lang from '../../../lang';

const cache = new Cache({
    prefix: 'pcuplive'
});

const bindType = 15;
let GoogleAuth;

function updateSigninStatus(isSignedIn) {
    // When signin status changes, this function is called.
    // If the signin status is changed to signedIn, we make an API call.
    // console.warn('isSignedIn', isSignedIn);
    if (isSignedIn) {
        // 登录成功
        var GoogleUser = GoogleAuth.currentUser.get();
        var { access_token } = GoogleUser.getAuthResponse()
        var profileData = GoogleUser.getBasicProfile();
        // console.warn('profileData', profileData);
        $.channel.emit('fbOauthSuccess', {
            access_token: access_token,
            profileData: profileData
        });
    } else {
        let promise = GoogleAuth.signIn();
        promise.then(()=>{},(error)=>{
            loading.hide();
            notification.simple(lang.template('授权失败'));
        });
    }
}

let google = Object.assign({
    go() {
        loading.show({
            content: lang.template('正在登录')
        });
        let loadedsdk = false;
        ((d, s, id, cb) => {
            const element = d.getElementsByTagName(s)[0];
            const fjs = element;
            let js = element;
            js = d.createElement(s);
            js.id = id;
            js.src = '//apis.google.com/js/platform.js';
            fjs.parentNode.insertBefore(js, fjs);
            js.onload = cb;
        })(document, 'script', 'google-login', () => {
            let loadedsdk = true;
            this.loadSdkTimer && clearTimeout(this.loadSdkTimer);
            // console.warn('google sdk loaded');
            try {
                gapi.load('auth2', () => {
                    gapi.auth2.init({
                        client_id: upInfoInSNS.google.clientId,
                        scope: 'profile email'
                    }).then(() => {
                        // console.warn('google sdk init');
                        
                            GoogleAuth = gapi.auth2.getAuthInstance();

                            GoogleAuth.isSignedIn.listen(updateSigninStatus);
                        

                        // Handle the initial sign-in state.
                        updateSigninStatus(GoogleAuth.isSignedIn.get());
                    });
                })

                $.channel.on('fbOauthSuccess', (data) => {
                    $.channel.off('fbOauthSuccess');
                    this.getGoogleInfo(data);
                });
            } catch (error) {
                loading.hide();
                notification.simple(lang.template('授权失败'));
            }
        });

        this.loadSdkTimer = setTimeout(()=>{
            if (!loadedsdk) {
                loading.hide();
                notification.simple(lang.template('授权失败'));
                new Error("gapi.load Auth2 Timeout")
            }
        }, 3 * 1000)
    },

    getGoogleInfo(data) {
        // console.warn('getGoogleInfo');
        let isRegistered = this.checkRegistered(data);

        isRegistered.done((registered) => {
            if (registered) {
                // 三方账号已绑定Up直播
                this.getProfileForRegister(data);
            } else {
                // 未绑定
                this.getProfileForNoRegister(data);
            }
        });

        isRegistered.fail(()=>{
            alert('dd');
        })
    },

    getProfileForNoRegister(data) {
        let registerPromise = this.register(data);

        registerPromise.done((data) => {

            let loginPromise = this.login(data.uid, data.password);

            loginPromise.done((data) => {
                // console.log('用户信息', data);

                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);

                loading.hide();

                UP.Global.DA.add({
                    eventName: 'loginSuccess',
                    action: 'show'
                });

                UP.Global.DA.add({
                    eventName: 'googleLoginSuccess',
                    action: 'click'
                });

                fbq('track', 'LoginSuccess', { oauthtype: 'google'});

                // location.reload();
                
                UP.Global.writeUserInfo(data);
                $.channel.emit('loginSuccess', data);
            });

            loginPromise.fail((dataWrap)=>{
                loading.hide();
                if (dataWrap.code == 4119) {
                    notification.simple('device forbidden');
                }
            })
        });

        registerPromise.fail((dataWrap)=>{
            loading.hide();
            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            }
            
        })
    },

    getProfileForRegister(data) {
        let registerPromise = this.register(data);

        registerPromise.done((data) => {
            console.log('用户信息', data);

            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            UP.Global.writeUserInfo(data);

            loading.hide();

            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            UP.Global.DA.add({
                eventName: 'googleLoginSuccess',
                action: 'click'
            });

            fbq('track', 'LoginSuccess', { oauthtype: 'google'});

            // location.reload();

            $.channel.emit('loginSuccess', data);
        });
        
        registerPromise.fail((dataWrap)=>{
            loading.hide();

            if (dataWrap.code == 4119) {
                notification.simple('device forbidden');
            }
            
        })
    },

    /*
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered(data) {
        let promise = new CheckRegister({
            bindType: bindType,
            thirdId: data.profileData.getId(),
            thirdToken: data.access_token
        }).promise;

        return promise;
    },

    register(data) {
        // let _lang = UP.Global.systemLanguage;
        // let countryCode = _lang.split('-')[1].toUpperCase();
        let { profileData, access_token } = data;
        let promise = new Register({
            bindType: bindType,
            thirdId: profileData.getId(),
            thirdToken: access_token,
            avatar: profileData.getImageUrl(),
            username: profileData.getName(),
            // countryCode: countryCode
        }).promise;

        return promise;
    },

    login(uid, password) {
        let promise = new UserLogin({
            loginType: 1,
            bindType: bindType,
            uid: uid,
            password: password,
        }).promise;

        return promise;
    }

}, events);

module.exports = google;


// WEBPACK FOOTER //
// ./js/component/thirdparty-login/google/index.js